import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { sharedTableStyles } from '../../utils/tableStyles';
import { TableSkeleton, CardSkeleton } from '../../components/UI/Skeleton/Skeleton';
import RowActionMenu from '../../components/UI/RowActionMenu/RowActionMenu';
import Select from 'react-select';
import { yupResolver } from '@hookform/resolvers/yup';
import _debounce from 'lodash/debounce';
import { Controller, useForm } from 'react-hook-form';
import DataTable from 'react-data-table-component';
import AdminNotes from './Notes';
import MITBanner from '../../assets/images/mit-banner.jpg';
import {
  useAddEmployeeMutation,
  useDeleteEmployeeMutation,
  useEditEmployeeMutation,
  useGetEmployeeQuery,
  useGetEmployeeByIdQuery,
  useGetEmployeeDropDownQuery
} from '../../redux/apis/employee';
import { useUploadFileMutation } from '../../redux/apis/files';
import { useGetDesignationQuery } from '../../redux/apis/Designation';

import OurClients from '../../components/Clients/OurClients';
import { HolidaysData } from '../../components/Data/AppData';
import PageHeader from '../../components/common/PageHeader';
import DeleteModel from '../../components/common/DeleteModel';
import ConfirmDialog from '../../components/common/ConfirmDialog';
import EmptyData from '../../components/UI/EmptyData';
import SingleSelectBox from '../../components/UI/SingleSelectBox';

import { employeeSchema } from '../../utils/schemas/auth';
import { notification } from '../../utils/notification';
import {
  convertTimeStamp,
  editDateFormate,
  // paginationRow,
  skipRow,
  fullName,
  profileImageFullName,
  withoutProfilePicture,
  // departmentOptions,
  getErrorMessage
} from '../../utils/handler';
import { BT_BUTTON_LABELS } from '../../utils/constant/buttons';
import {
  CONFIRMATION_SWITCH,
  GENDER_OPTION,
  INPUT_LABEL,
  MARITAL_STATUS_OPTION,
  PLACEHOLDER,
  SOURCE_OF_HIRE
} from '../../utils/constant/placeHolders';
import { LB_EMPLOYEE, LB_EMPLOYEE_SORT_KEYS, LB_HEADER } from '../../utils/constant/labels';
import {
  EMPLOYEE_TYPE_OPTION,
  GLOBAL,
  ROLES,
  TABLE_ROW,
  getRecordLocality
} from '../../utils/constant/global';
import { TOAST_TYPE } from '../../utils/constant/errorMessage';
import { countryData } from '../../utils/data/countryData';

import moment from 'moment';
import { useGetDepartmentQuery } from '../../redux/apis/department';
import { useGetSystemRoleQuery } from '../../redux/apis/systemRoleApi';
import { selectOfficeLocality } from '../../redux/Slice/officeSlice';
import './Members.scss';

const { BTN_SAVE, BTN_CANCEL } = BT_BUTTON_LABELS;
const {
  LB_FULL_NAME,
  LB_EMPLOYEE_CODE,
  LB_SOURCE_HR,
  LB_MOBILE,
  LB_COM_EMAIL,
  LB_DATE_OF_JOINING,
  LB_DOB,
  LB_EMERGENCY_MOBILE,
  LB_PERSONAL_EMAIL,
  LB_ADDRESS,
  LB_NATIONALITY,
  LB_GENDER_LABEL,
  LB_MARITAL_STATUS_LABEL,
  LB_EMPLOYEE_TYPE,
  LB_DESIGNATION_LABEL,
  LB_DEPARTMENT_LABEL,
  LB_REPORTING_MANAGER,
  LB_REPORTING_TL,
  LB_COMPANY_ADDRESS,
  LB_WORK,
  LB_PERSONAL_INFORMATION,
  LB_WORK_EXPERIENCE,
  LB_EDUCATION_DETAIL,
  LB_COMPANY_NAME,
  LB_JOB_TITLE,
  LB_FROM_DATE,
  LB_TO_DATE,
  LB_INSTITUTE_NAME,
  LB_DEGREE,
  LB_SPECIALIZATION,
  LB_DATE_COMPLETION,
  LB_EMPLOYEE_ROLE
} = INPUT_LABEL;
const { TOAST_SUCCESS, TOAST_ERROR } = TOAST_TYPE;
const { ROW, DESC, ASC } = GLOBAL;
const { EMPLOYEE, MANAGEMENT, LEAD, ADMIN } = ROLES;
const { LB_ADD_EMPLOYEE_HEADER, LB_EDIT_EMPLOYEE_HEADER } = LB_HEADER;
const {
  PH_FULL_NAME,
  PH_EMPLOYEE_CODE,
  PH_MOBILE,
  PH_SEARCH_INPUT,
  PH_NATIONALITY,
  PH_SOURCE_HIRE,
  PH_EMPLOYEE_ROLE
} = PLACEHOLDER;
const {
  LB_TBL_COL_EMPLOYEE_NAME,
  LB_EMPLOYEE_EMAIL,
  LB_EMPLOYEE_MOBILE,
  LB_EMPLOYEE_DESIGNATION,
  LB_EMPLOYEE_ACTION
} = LB_EMPLOYEE;

const { SR_EMPLOYEE_NAME, SR_EMPLOYEE_EMAIL, SR_EMPLOYEE_MOBILE } = LB_EMPLOYEE_SORT_KEYS;

const mergeEmployeesById = (...lists) => {
  const byId = new Map();
  lists.forEach((list) => {
    (Array.isArray(list) ? list : []).forEach((user) => {
      if (user?._id) byId.set(user._id, user);
    });
  });
  return Array.from(byId.values());
};

const toEmployeeSelectOptions = (users = []) =>
  users.map((val) => ({
    value: val._id,
    label: val.name || val.userName || val.email || '—'
  }));

const getEmployeeByIdPayload = (response) => {
  const payload = response?.data;
  if (payload?._id) return payload;
  if (payload?.data?._id) return payload.data;
  return null;
};

const toRecordId = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  return value._id || '';
};

const keepPopulated = (existing, next) =>
  existing &&
  typeof existing === 'object' &&
  (existing.name || existing.roleName || existing.userName)
    ? existing
    : next;

const keepPopulatedList = (existing, next) =>
  Array.isArray(existing) &&
  existing.some((item) => item && typeof item === 'object' && (item.name || item.userName))
    ? existing
    : next;

const looksLikeMongoId = (value) => typeof value === 'string' && /^[a-fA-F0-9]{24}$/.test(value);

const displayName = (value) => {
  if (!value) return '';
  if (typeof value === 'object') return value.name || value.userName || '';
  if (looksLikeMongoId(value)) return '';
  return value;
};

const getExperienceDisplayRows = (employee) => {
  if (Array.isArray(employee?.workExperience) && employee.workExperience.length) {
    return employee.workExperience.map((item) => ({
      company: item?.companyName || '-',
      title: item?.jobTitle || item?.title || '-',
      start: item?.fromDate || item?.start,
      end: item?.toDate === 0 || item?.end === 0 ? 0 : (item?.toDate ?? item?.end)
    }));
  }
  if (Array.isArray(employee?.experience) && employee.experience.length) {
    return employee.experience.map((item) => ({
      company: displayName(item?.companyName) || '-',
      title: item?.title || item?.jobTitle || '-',
      start: item?.start || item?.fromDate,
      end: item?.end === 0 || item?.toDate === 0 ? 0 : (item?.end ?? item?.toDate)
    }));
  }
  return [];
};

const getEducationDisplayRows = (employee) => {
  if (Array.isArray(employee?.educationDetails) && employee.educationDetails.length) {
    return employee.educationDetails.map((item) => ({
      institute: item?.instituteName || '-',
      degree: item?.degree || '-',
      specialization: item?.specialization || '-',
      year: item?.dateofCompletion || '-'
    }));
  }
  if (Array.isArray(employee?.education) && employee.education.length) {
    return employee.education.map((item) => ({
      institute: displayName(item?.eduInfo?.institute) || '-',
      degree: displayName(item?.eduInfo?.degree) || '-',
      specialization: displayName(item?.eduInfo?.fieldOfStudy) || '-',
      year: item?.eduInfo?.end ? new Date(parseInt(item.eduInfo.end, 10)).getFullYear() : '-'
    }));
  }
  return [];
};

const DROPDOWN_PAGE_SIZE = 50;

const EMPLOYEE_ACTIVE_OPTIONS = [
  { value: true, label: 'Active' },
  { value: false, label: 'Inactive' }
];

const initialState = {
  employeeList: [],
  isModal: false,
  search: '',
  isActiveFilter: true,
  isEditModalData: {},
  isDelete: { id: '', status: '' },
  grid: false,
  currentPage: 1,
  rowsPerPage: 10,
  currentPageDropdown: 1,
  rowsPerPageDropdown: 50,
  isNext: false,
  sortField: 'name',
  sortDirection: true,
  loading: false,
  yearsOption: [],
  designationSelect: '',
  reportingManagerSelect: '',
  departmentSelect: '',
  dropdownDataStore: [],
  reportingTeamLeadList: [],
  designationDropdownPage: 1,
  designationDropdownStore: [],
  designationDropdownSearch: '',
  designationDropdownSearchStore: [],
  designationDropdownIsNext: false,
  departmentDropdownPage: 1,
  departmentDropdownStore: [],
  departmentDropdownSearch: '',
  departmentDropdownSearchStore: [],
  departmentDropdownIsNext: false,
  drawerOpen: false,
  selectedRowUserId: null,
  noteDrawer: false,
  rowLoading: {},
  activeConfirm: null,
  activeSaving: false
};

function Members() {
  const officeLocality = useSelector(selectOfficeLocality);
  const isAuOffice = officeLocality.includes('AU');
  const navigate = useNavigate();
  const [state, setState] = useState(initialState);
  const [formTab, setFormTab] = useState('personal');
  const openEmployeeDetails = (employee) => {
    if (!employee?._id) return;
    navigate(`/employees/${employee._id}?tab=personal`, { state: { employee } });
  };
  const employeeTableStyles = {
    ...sharedTableStyles,
    headCells: {
      style: {
        ...sharedTableStyles.headCells.style,
        color: '#334155'
      }
    },
    rows: {
      ...sharedTableStyles.rows,
      style: {
        ...sharedTableStyles.rows.style,
        color: '#1f2937'
      }
    },
    cells: {
      style: {
        ...sharedTableStyles.cells.style,
        color: '#1f2937',
        fontWeight: 600
      }
    }
  };
  const {
    data: designationDropdownResponse,
    isFetching: designationDropdownFetching,
    refetch: refetchDesignationDropdown
  } = useGetDesignationQuery({
    search: state.designationDropdownSearch,
    skip: skipRow(state.designationDropdownPage, DROPDOWN_PAGE_SIZE),
    limit: DROPDOWN_PAGE_SIZE
  });

  const {
    data: departmentDropdownResponse,
    isFetching: departmentDropdownFetching,
    refetch: refetchDepartmentDropdown
  } = useGetDepartmentQuery({
    search: state.departmentDropdownSearch,
    skip: skipRow(state.departmentDropdownPage, DROPDOWN_PAGE_SIZE),
    limit: DROPDOWN_PAGE_SIZE
  });

  const {
    data,
    isLoading,
    isFetching,
    refetch: employeeFetch
  } = useGetEmployeeQuery({
    search: state.search,
    skip: skipRow(state.currentPage, state.rowsPerPage),
    limit: state.rowsPerPage,
    hrxRole: EMPLOYEE,
    isActive: state.isActiveFilter,
    sort: state.sortField,
    sortType: state.sortDirection ? ASC : DESC
  });

  const editEmployeeId = state.isModal ? state.isEditModalData?._id : undefined;
  const {
    data: employeeByIdResponse,
    isFetching: isEmployeeDetailFetching,
    refetch: refetchEmployeeById
  } = useGetEmployeeByIdQuery(editEmployeeId, {
    skip: !editEmployeeId,
    refetchOnMountOrArgChange: true
  });
  const employeeDetail = getEmployeeByIdPayload(employeeByIdResponse);

  const {
    data: dropdownData,
    isLoading: dropdownDataLoading,
    isFetching: dropdownDataIsFetching,
    refetch: employeeDropDownQuery
  } = useGetEmployeeDropDownQuery(
    { limit: 100, hrxRole: MANAGEMENT },
    { refetchOnMountOrArgChange: true }
  );
  const {
    data: teamLead,
    isLoading: teamLeadLoading,
    isFetching: teamLeadDataIsFetching,
    refetch: teamLeadDropDownQuery
  } = useGetEmployeeDropDownQuery(
    { limit: 100, hrxRole: LEAD },
    { refetchOnMountOrArgChange: true }
  );
  const { data: adminDropdown, refetch: adminDropDownQuery } = useGetEmployeeDropDownQuery(
    { limit: 100, hrxRole: ADMIN },
    { skip: !isAuOffice, refetchOnMountOrArgChange: true }
  );

  const projectManagerOptions = useMemo(
    () =>
      toEmployeeSelectOptions(
        mergeEmployeesById(dropdownData?.data, isAuOffice ? adminDropdown?.data : [])
      ),
    [dropdownData?.data, adminDropdown?.data, isAuOffice]
  );

  const teamLeadOptions = useMemo(
    () =>
      toEmployeeSelectOptions(
        mergeEmployeesById(teamLead?.data, isAuOffice ? adminDropdown?.data : [])
      ),
    [teamLead?.data, adminDropdown?.data, isAuOffice]
  );

  const designationOptions = useMemo(() => {
    const hasSearch = Boolean(state.designationDropdownSearch?.trim());
    let list = hasSearch ? state.designationDropdownSearchStore : state.designationDropdownStore;
    const selected = state.isEditModalData?.designation;
    if (selected?._id && !list.some((item) => item._id === selected._id)) {
      list = [{ _id: selected._id, name: selected.name }, ...list];
    }
    return toEmployeeSelectOptions(list);
  }, [
    state.designationDropdownSearch,
    state.designationDropdownSearchStore,
    state.designationDropdownStore,
    state.isEditModalData?.designation
  ]);

  const departmentOptions = useMemo(() => {
    const hasSearch = Boolean(state.departmentDropdownSearch?.trim());
    let list = hasSearch ? state.departmentDropdownSearchStore : state.departmentDropdownStore;
    const selected = state.isEditModalData?.department;
    if (selected?._id && !list.some((item) => item._id === selected._id)) {
      list = [{ _id: selected._id, name: selected.name }, ...list];
    }
    return toEmployeeSelectOptions(list);
  }, [
    state.departmentDropdownSearch,
    state.departmentDropdownSearchStore,
    state.departmentDropdownStore,
    state.isEditModalData?.department
  ]);

  const designationUsesServerSearch = Boolean(state.designationDropdownSearch?.trim());
  const departmentUsesServerSearch = Boolean(state.departmentDropdownSearch?.trim());

  const debouncedDesignationSearch = useMemo(
    () =>
      _debounce((text) => {
        const term = String(text || '').trim();
        setState((prev) => ({
          ...prev,
          designationDropdownSearch: term,
          designationDropdownPage: 1,
          ...(term ? { designationDropdownSearchStore: [] } : {})
        }));
      }, 300),
    []
  );

  const debouncedDepartmentSearch = useMemo(
    () =>
      _debounce((text) => {
        const term = String(text || '').trim();
        setState((prev) => ({
          ...prev,
          departmentDropdownSearch: term,
          departmentDropdownPage: 1,
          ...(term ? { departmentDropdownSearchStore: [] } : {})
        }));
      }, 300),
    []
  );

  const debouncedDesignationSearchRef = useRef(debouncedDesignationSearch);
  const debouncedDepartmentSearchRef = useRef(debouncedDepartmentSearch);
  debouncedDesignationSearchRef.current = debouncedDesignationSearch;
  debouncedDepartmentSearchRef.current = debouncedDepartmentSearch;

  useEffect(
    () => () => {
      debouncedDesignationSearchRef.current.cancel();
      debouncedDepartmentSearchRef.current.cancel();
    },
    []
  );

  const [addEmployee] = useAddEmployeeMutation();
  const [editEmployee] = useEditEmployeeMutation();
  const [deleteEmployee] = useDeleteEmployeeMutation();
  const [uploadFile] = useUploadFileMutation();
  const profilePicInputRef = useRef(null);
  const [profilePicUploading, setProfilePicUploading] = useState(false);
  const {
    data: roleList,
    // isError,
    refetch: refetchSystemRoles
  } = useGetSystemRoleQuery();

  const roleOptions = roleList?.data?.map((role) => ({
    value: role._id,
    label: role.roleName
  }));

  const handleChangeSort = (sortField) => {
    setState({ ...state, sortDirection: !state.sortDirection, sortField: sortField.sortField });
  };

  useEffect(() => {
    try {
      refetchDesignationDropdown();
      refetchDepartmentDropdown();
      employeeFetch();
      refetchSystemRoles();
    } catch (error) {
      notification(error.message, TOAST_ERROR);
    }
  }, []);

  useEffect(() => {
    const rows = designationDropdownResponse?.data;
    if (!Array.isArray(rows)) return;

    setState((prev) => {
      const isSearchActive = Boolean(prev.designationDropdownSearch?.trim());

      if (isSearchActive) {
        const merged =
          prev.designationDropdownPage === 1
            ? rows
            : mergeEmployeesById(prev.designationDropdownSearchStore, rows);
        return {
          ...prev,
          designationDropdownSearchStore: merged,
          designationDropdownIsNext: Boolean(designationDropdownResponse?.isNext)
        };
      }

      const shouldSeed =
        prev.designationDropdownPage === 1 && prev.designationDropdownStore.length === 0;
      const merged = shouldSeed
        ? rows
        : prev.designationDropdownPage === 1
          ? prev.designationDropdownStore
          : mergeEmployeesById(prev.designationDropdownStore, rows);

      return {
        ...prev,
        designationDropdownStore: merged,
        designationDropdownIsNext: Boolean(designationDropdownResponse?.isNext)
      };
    });
  }, [designationDropdownResponse]);

  useEffect(() => {
    const rows = departmentDropdownResponse?.data;
    if (!Array.isArray(rows)) return;

    setState((prev) => {
      const isSearchActive = Boolean(prev.departmentDropdownSearch?.trim());

      if (isSearchActive) {
        const merged =
          prev.departmentDropdownPage === 1
            ? rows
            : mergeEmployeesById(prev.departmentDropdownSearchStore, rows);
        return {
          ...prev,
          departmentDropdownSearchStore: merged,
          departmentDropdownIsNext: Boolean(departmentDropdownResponse?.isNext)
        };
      }

      const shouldSeed =
        prev.departmentDropdownPage === 1 && prev.departmentDropdownStore.length === 0;
      const merged = shouldSeed
        ? rows
        : prev.departmentDropdownPage === 1
          ? prev.departmentDropdownStore
          : mergeEmployeesById(prev.departmentDropdownStore, rows);

      return {
        ...prev,
        departmentDropdownStore: merged,
        departmentDropdownIsNext: Boolean(departmentDropdownResponse?.isNext)
      };
    });
  }, [departmentDropdownResponse]);

  const defaultValue = {
    name: '',
    zohoEmployeeId: '',
    lastName: '',
    email: '',
    phone: '',
    dateOfJoining: null,
    dateOfBirth: null,
    sourceOfHire: '',
    emergencyMobile: '',
    personalEmail: '',
    location: '',
    gender: '',
    nationality: '',
    maritalStatus: '',
    employmentType: '',
    department: '',
    designation: '',
    reportingManager: [],
    workExperience: [],
    educationDetails: [],
    allowWorkFromHome: false,
    isActive: true,
    isConfirmationDone: false,
    reportingTeamLead: '',
    hrxRole: ''
  };
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    control,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(employeeSchema),
    values: state.isEditModalData?._id
      ? {
          ...state.isEditModalData,
          department: toRecordId(state.isEditModalData?.department),
          designation: toRecordId(state.isEditModalData?.designation),
          reportingManager:
            Array.isArray(state.isEditModalData?.reportingManager) &&
            state.isEditModalData.reportingManager.length > 0
              ? state.isEditModalData.reportingManager.map(toRecordId).filter(Boolean)
              : [],
          reportingTeamLead:
            Array.isArray(state.isEditModalData?.reportingTeamLead) &&
            state.isEditModalData.reportingTeamLead.length > 0
              ? toRecordId(state.isEditModalData.reportingTeamLead[0])
              : toRecordId(state.isEditModalData?.reportingTeamLead) || null,
          employmentType: state.isEditModalData?.employmentType,
          companyAddress: state.isEditModalData?.companyAddress,
          allowWorkFromHome: state.isEditModalData?.allowWorkFromHome || false,
          isActive: state.isEditModalData?.isActive !== false,
          isConfirmationDone: state.isEditModalData.isConfirmationDone || false,
          hrxRoleData: toRecordId(state.isEditModalData?.hrxRole)
        }
      : defaultValue
  });
  const valuesData = watch();
  const editEmployeeData = async (data) => {
    try {
      setState({ ...state, loading: true });

      const res = await editEmployee({ data: data, id: state?.isEditModalData?._id });
      if (res.data?.success) {
        employeeFetch();
        if (editEmployeeId) refetchEmployeeById();
        setState({ ...state, reportingManagerSelect: '', isModal: false, loading: false });
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
      } else {
        reset();
        setState({ ...state, reportingManagerSelect: '', isModal: false, loading: false });
        notification(res?.data?.statusMessage, TOAST_ERROR);
      }
    } catch (error) {
      notification(error.message, TOAST_ERROR);
    }
  };

  const addEmployeeData = async (data) => {
    try {
      setState({ ...state, loading: true });
      const employeeData = {
        ...data,
        role: EMPLOYEE
      };
      const res = await addEmployee(employeeData);
      if (res.data?.success) {
        employeeFetch();
        setState({ ...state, reportingManagerSelect: '', isModal: false, loading: false });
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
      } else {
        reset();
        setState({ ...state, reportingManagerSelect: '', isModal: false, loading: false });
        notification(res?.data?.statusMessage, TOAST_ERROR);
      }
    } catch (error) {
      notification(error.message, TOAST_ERROR);
    }
  };

  const handleProfilePicChange = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      notification('Please select an image file', TOAST_ERROR);
      return;
    }

    const previewUrl = URL.createObjectURL(file);
    setState((prev) => ({
      ...prev,
      isEditModalData: {
        ...prev.isEditModalData,
        profilePicture: previewUrl
      }
    }));

    try {
      setProfilePicUploading(true);
      const formData = new FormData();
      formData.append('files', file);
      const response = await uploadFile(formData);

      if (!response?.data?.success) {
        notification(
          response?.data?.message || response?.error?.data?.statusMessage || 'Upload failed',
          TOAST_ERROR
        );
        return;
      }

      const uploadedUrl = response.data.data?.files?.[0]?.location;
      if (!uploadedUrl) {
        notification('Upload failed', TOAST_ERROR);
        return;
      }

      setState((prev) => ({
        ...prev,
        isEditModalData: {
          ...prev.isEditModalData,
          profilePicture: uploadedUrl
        }
      }));

      if (state.isEditModalData?._id) {
        const locality = getRecordLocality(state.isEditModalData);
        const res = await editEmployee({
          data: {
            profilePicture: uploadedUrl,
            ...(locality.length ? { locality } : {})
          },
          id: state.isEditModalData._id
        });

        if (res?.data?.success) {
          notification(res.data.statusMessage, TOAST_SUCCESS);
          employeeFetch();
          refetchEmployeeById();
        } else {
          notification(
            res?.error?.data?.statusMessage ||
              res?.data?.statusMessage ||
              'Could not save profile picture',
            TOAST_ERROR
          );
        }
      }
    } catch (error) {
      notification(error?.message || 'Something went wrong', TOAST_ERROR);
    } finally {
      setProfilePicUploading(false);
    }
  };

  const onSubmit = (data) => {
    try {
      const employeeData = {
        userName: fullName(data),
        name: data.name,
        lastName: data.lastName,
        zohoEmployeeId: data.zohoEmployeeId?.trim?.() || data.zohoEmployeeId,
        email: data.email,
        phone: data.phone,
        dateOfJoining: data.dateOfJoining,
        dateOfBirth: data.dateOfBirth,
        gender: data.gender,
        maritalStatus: data.maritalStatus,
        nationality: data.nationality,
        emergencyMobile: data.emergencyMobile,
        personalEmail: data.personalEmail,
        location: data.location,
        sourceOfHire: data.sourceOfHire,
        employmentType: data.employmentType,
        companyAddress: data.companyAddress,
        hrxRole: valuesData?.hrxRoleData,
        reportingTeamLead: [valuesData.reportingTeamLead],
        reportingManager: valuesData.reportingManager,
        educationDetails: data.educationDetails,
        workExperience: data.workExperience,
        department: data.department,
        allowWorkFromHome: data.allowWorkFromHome,
        isActive: data.isActive !== false,
        designation: data.designation,
        locality:
          Array.isArray(data.locality) && data.locality.length
            ? data.locality
            : getRecordLocality(state.isEditModalData),
        isConfirmationDone:
          data?.isConfirmationDone === 'true' || data?.isConfirmationDone === true ? true : false,
        ...(typeof state.isEditModalData?.profilePicture === 'string' &&
        state.isEditModalData.profilePicture.startsWith('http')
          ? { profilePicture: state.isEditModalData.profilePicture }
          : {})
      };

      if (state.isEditModalData._id) {
        editEmployeeData(employeeData);
      } else {
        addEmployeeData(employeeData);
      }
    } catch (error) {
      notification(getErrorMessage(error), TOAST_ERROR);
    }
  };

  const WFHSwitch = ({ value, onChange, loading, tone = 'brand' }) => (
    <div
      className={`employee-wfh-switch form-check form-switch theme-switch${
        tone === 'success' ? ' is-success' : ''
      }${value ? ' is-on' : ''}`}
    >
      <input
        className="form-check-input"
        type="checkbox"
        checked={value}
        disabled={loading}
        onChange={(e) => onChange(e.target.checked)}
      />
      {loading ? (
        <span className="employee-wfh-switch__loader" role="status" aria-label="Saving">
          <span className="spinner-border" />
        </span>
      ) : null}
    </div>
  );

  const requestActiveChange = (row, nextValue) => {
    setState((prev) => ({
      ...prev,
      activeConfirm: { row, nextValue: Boolean(nextValue) }
    }));
  };

  const closeActiveConfirm = () => {
    setState((prev) => {
      if (prev.activeSaving) return prev;
      return { ...prev, activeConfirm: null };
    });
  };

  const confirmActiveChange = async () => {
    const pending = state.activeConfirm;
    if (!pending?.row?._id || state.activeSaving) return;

    const { row, nextValue } = pending;
    setState((prev) => ({ ...prev, activeSaving: true }));

    try {
      const res = await editEmployee({
        id: row._id,
        data: {
          isActive: nextValue,
          locality: getRecordLocality(row)
        }
      });

      if (res?.data?.success) {
        notification(
          res?.data?.statusMessage ||
            (nextValue ? 'Employee marked active.' : 'Employee marked inactive.'),
          TOAST_SUCCESS
        );
        setState((prev) => ({
          ...prev,
          activeSaving: false,
          activeConfirm: null,
          employeeList: prev.employeeList.filter((item) => item._id !== row._id)
        }));
        employeeFetch();
        return;
      }

      setState((prev) => ({ ...prev, activeSaving: false }));
      notification(
        res?.error?.data?.statusMessage ||
          res?.error?.message ||
          res?.data?.statusMessage ||
          'Failed to update employee status.',
        TOAST_ERROR
      );
    } catch (error) {
      setState((prev) => ({ ...prev, activeSaving: false }));
      notification(error?.message || 'Failed to update employee status.', TOAST_ERROR);
    }
  };

  const handleWFHToggle = async (row, value) => {
    const nextValue = typeof value === 'boolean' ? value : !row.allowWorkFromHome;

    setState((prev) => ({
      ...prev,
      rowLoading: { ...prev.rowLoading, [row?._id]: true }
    }));

    try {
      const res = await editEmployee({
        id: row._id,
        data: {
          allowWorkFromHome: nextValue,
          locality: getRecordLocality(row)
        }
      });

      if (res?.data?.success) {
        setState((prev) => ({
          ...prev,
          rowLoading: { ...prev.rowLoading, [row?._id]: false },
          employeeList: prev.employeeList.map((item) =>
            item._id === row._id ? { ...item, allowWorkFromHome: nextValue } : item
          )
        }));
        return;
      }

      setState((prev) => ({
        ...prev,
        rowLoading: { ...prev.rowLoading, [row?._id]: false }
      }));
      notification(
        res?.error?.data?.statusMessage ||
          res?.error?.message ||
          res?.data?.statusMessage ||
          'Failed to update work from home.',
        TOAST_ERROR
      );
    } catch (error) {
      setState((prev) => ({
        ...prev,
        rowLoading: { ...prev.rowLoading, [row?._id]: false }
      }));
      notification(error?.message || 'Failed to update work from home.', TOAST_ERROR);
    }
  };

  const onDeleteUser = async (id) => {
    try {
      const res = await deleteEmployee(id);
      if (res.data?.success) {
        employeeFetch();
        setState({ ...state, isDelete: { id: '', status: false } });
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
      } else {
        reset();
        notification(res?.data?.statusMessage, TOAST_ERROR);
      }
    } catch (error) {
      notification(error.message, TOAST_ERROR);
    }
  };

  var columnsT = '';

  columnsT = [
    {
      name: LB_TBL_COL_EMPLOYEE_NAME,
      sortField: SR_EMPLOYEE_NAME,
      cell: (row) => profileImageFullName(row),
      sortable: true,
      minWidth: '320px',
      grow: 2,
      wrap: true
    },
    {
      name: LB_EMPLOYEE_EMAIL,
      sortField: SR_EMPLOYEE_EMAIL,
      selector: (row) => <span className={row.txtClass}>{row.email || ''}</span>,
      sortable: true,
      minWidth: '220px',
      grow: 1.4
    },
    {
      name: LB_EMPLOYEE_MOBILE,
      sortField: SR_EMPLOYEE_MOBILE,
      selector: (row) => <span className={row.txtClass}>{row.phone || ''}</span>,
      sortable: false,
      width: '148px'
    },
    {
      name: LB_EMPLOYEE_DESIGNATION,
      selector: (row) => (
        <span className="employee-designation-cell" title={row?.designation?.name || ''}>
          {row?.designation?.name || '-'}
        </span>
      ),
      sortable: false,
      minWidth: '180px',
      grow: 1.2,
      wrap: true
    },
    {
      name: 'WFH',
      sortable: false,
      width: '88px',
      center: true,
      cell: (row) => (
        <WFHSwitch
          value={row.allowWorkFromHome}
          loading={!!state.rowLoading[row._id]}
          onChange={(value) => handleWFHToggle(row, value)}
        />
      )
    },
    {
      name: 'STATUS',
      sortable: false,
      width: '168px',
      center: true,
      cell: (row) => {
        const active = row.isActive !== false;
        return (
          <div className={`employee-status-toggle${active ? ' is-on' : ' is-off'}`}>
            <span className="employee-status-toggle__label">{active ? 'Active' : 'Inactive'}</span>
            <WFHSwitch
              tone="success"
              value={active}
              loading={state.activeSaving && state.activeConfirm?.row?._id === row._id}
              onChange={(value) => requestActiveChange(row, value)}
            />
          </div>
        );
      }
    },

    {
      name: LB_EMPLOYEE_ACTION,
      selector: () => {},
      sortable: false,
      width: '84px',
      right: true,
      cell: (row) => (
        <RowActionMenu
          actions={[
            {
              label: 'Edit',
              icon: 'icofont-edit',
              variant: 'success',
              onClick: () => openEmployeeDetails(row)
            },
            {
              label: 'Files',
              icon: 'icofont-document-folder',
              hidden: isAuOffice,
              onClick: () => navigate(`/employees/${row._id}/files`)
            },
            {
              label: 'Note',
              icon: 'icofont-ui-note',
              onClick: () => setState({ ...state, noteDrawer: true, selectedRowUserId: row._id })
            }
          ]}
        />
      )
    }
  ];

  useEffect(() => {
    employeeFetch();
  }, [
    state.rowsPerPage,
    state.currentPage,
    state.search,
    state.isActiveFilter,
    state.sortDirection
  ]);

  useEffect(() => {
    if (!state.isModal) return;
    setFormTab('personal');
    window.scrollTo(0, 0);
    employeeDropDownQuery();
    teamLeadDropDownQuery();
    if (isAuOffice) adminDropDownQuery();
  }, [state.isModal, isAuOffice, employeeDropDownQuery, teamLeadDropDownQuery, adminDropDownQuery]);

  const handleChangePage = (page) => {
    setState({ ...state, currentPage: page });
  };

  const handleChangeRowsPerPage = (newRowsPerPage) => {
    setState({ ...state, rowsPerPage: newRowsPerPage, currentPage: 1 });
  };

  const debouncedOnSearchData = _debounce((data) => {
    setState({ ...state, search: data });
  }, 500);

  const workExperience = {
    companyName: '',
    jobTitle: '',
    fromDate: null,
    toDate: null
  };

  const educationDetails = {
    instituteName: '',
    degree: '',
    specialization: '',
    dateofCompletion: null
  };

  useEffect(() => {
    if (valuesData?.workExperience?.length < 1) {
      setValue('workExperience', [workExperience]);
    }
    if (valuesData?.educationDetails?.length < 1) {
      setValue('educationDetails', [educationDetails]);
    }
  }, [valuesData]);

  useEffect(() => {
    const lastYear = 1960;
    const currentYear = Number(moment().format('YYYY')) + 10;
    const yearData = [];
    for (let i = lastYear; i < currentYear; i++) {
      yearData.push({ value: i, label: i });
    }
    // setState({ ...state, yearsOption: [...yearData], dropdownDataStore: dropdownData?.data || [] });
    setState({ ...state, yearsOption: [...yearData] });
  }, []);

  const handleMenuScrollToBottom = async () => {
    if (dropdownData?.isNext) {
      setState((prevState) => ({
        ...prevState,
        currentPageDropdown: prevState.currentPageDropdown + 1
      }));
      employeeDropDownQuery();
    }
  };

  const handleMenuScrollToBottomTeamLead = async () => {
    if (teamLead?.isNext) {
      setState((prevState) => ({
        ...prevState,
        currentPageDropdown: prevState.currentPageDropdown + 1
      }));
      teamLeadDropDownQuery();
    }
  };

  const handleMenuScrollToBottomDesignation = () => {
    if (!state.designationDropdownIsNext || designationDropdownFetching) return;
    setState((prev) => ({
      ...prev,
      designationDropdownPage: prev.designationDropdownPage + 1
    }));
  };

  const handleMenuScrollToBottomDepartment = () => {
    if (!state.departmentDropdownIsNext || departmentDropdownFetching) return;
    setState((prev) => ({
      ...prev,
      departmentDropdownPage: prev.departmentDropdownPage + 1
    }));
  };

  const resetDesignationDropdown = () => {
    debouncedDesignationSearch.cancel();
    setState((prev) => ({
      ...prev,
      designationDropdownSearch: '',
      designationDropdownPage: 1
    }));
  };

  const resetDepartmentDropdown = () => {
    debouncedDepartmentSearch.cancel();
    setState((prev) => ({
      ...prev,
      departmentDropdownSearch: '',
      departmentDropdownPage: 1
    }));
  };

  const openDesignationDropdown = () => {
    setState((prev) => ({
      ...prev,
      designationDropdownSearch: '',
      designationDropdownPage: 1
    }));
    if (!state.designationDropdownStore.length) {
      refetchDesignationDropdown();
    }
  };

  const openDepartmentDropdown = () => {
    setState((prev) => ({
      ...prev,
      departmentDropdownSearch: '',
      departmentDropdownPage: 1
    }));
    if (!state.departmentDropdownStore.length) {
      refetchDepartmentDropdown();
    }
  };

  const handleDesignationInputChange = (text, meta) => {
    if (meta.action !== 'input-change') return;
    const term = String(text || '').trim();

    if (!term) {
      debouncedDesignationSearch.cancel();
      setState((prev) => ({
        ...prev,
        designationDropdownSearch: '',
        designationDropdownPage: 1
      }));
      return;
    }

    const hasLocalMatch = state.designationDropdownStore.some((item) =>
      String(item?.name || '')
        .toLowerCase()
        .includes(term.toLowerCase())
    );

    if (hasLocalMatch) {
      debouncedDesignationSearch.cancel();
      setState((prev) => ({
        ...prev,
        designationDropdownSearch: '',
        designationDropdownPage: 1
      }));
      return;
    }

    debouncedDesignationSearch(term);
  };

  const handleDepartmentInputChange = (text, meta) => {
    if (meta.action !== 'input-change') return;
    const term = String(text || '').trim();

    if (!term) {
      debouncedDepartmentSearch.cancel();
      setState((prev) => ({
        ...prev,
        departmentDropdownSearch: '',
        departmentDropdownPage: 1
      }));
      return;
    }

    const hasLocalMatch = state.departmentDropdownStore.some((item) =>
      String(item?.name || '')
        .toLowerCase()
        .includes(term.toLowerCase())
    );

    if (hasLocalMatch) {
      debouncedDepartmentSearch.cancel();
      setState((prev) => ({
        ...prev,
        departmentDropdownSearch: '',
        departmentDropdownPage: 1
      }));
      return;
    }

    debouncedDepartmentSearch(term);
  };

  useEffect(() => {
    if (data?.data) {
      setState((prev) => ({
        ...prev,
        employeeList: data.data,
        isNext: data?.isNext
      }));
    }
  }, [data?.data]);

  useEffect(() => {
    if (!state.isModal || !employeeDetail?._id) return;
    if (employeeDetail._id !== state.isEditModalData?._id) return;

    setState((prev) => {
      const current = prev.isEditModalData;
      if (
        current?._detailId === employeeDetail._id &&
        current?._detailUpdatedAt === employeeDetail.updatedAt
      ) {
        return prev;
      }

      const localPicture = current?.profilePicture;
      const keepLocalPicture = typeof localPicture === 'string' && localPicture.startsWith('blob:');

      return {
        ...prev,
        isEditModalData: {
          ...employeeDetail,
          _detailId: employeeDetail._id,
          _detailUpdatedAt: employeeDetail.updatedAt,
          profilePicture: keepLocalPicture ? localPicture : employeeDetail.profilePicture,
          designation: keepPopulated(current?.designation, employeeDetail.designation),
          department: keepPopulated(current?.department, employeeDetail.department),
          hrxRole: keepPopulated(current?.hrxRole, employeeDetail.hrxRole),
          reportingManager: keepPopulatedList(
            current?.reportingManager,
            employeeDetail.reportingManager
          ),
          reportingTeamLead: keepPopulatedList(
            current?.reportingTeamLead,
            employeeDetail.reportingTeamLead
          )
        }
      };
    });
  }, [employeeDetail, state.isModal, state.isEditModalData?._id]);

  const isExistingEmployee = Boolean(state.isEditModalData?._id);
  const experienceRows = getExperienceDisplayRows(state.isEditModalData);
  const educationRows = getEducationDisplayRows(state.isEditModalData);
  const isSavingDisabled = state.loading || (isExistingEmployee && isEmployeeDetailFetching);

  return (
    <>
      {state.noteDrawer && (
        <AdminNotes
          props={{
            showDrawer: state.noteDrawer,
            handleClose: () => setState({ ...state, noteDrawer: false }),
            id: state.selectedRowUserId
          }}
        />
      )}
      {state.isModal ? (
        <div className="employee-form container-xxl">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="employee-form__card">
              <div className="employee-form__cover">
                <div className="employee-form__cover-media">
                  <img className="employee-form__cover-img" src={MITBanner} alt="" />
                  <span className="employee-form__cover-shade" aria-hidden />
                </div>
                <button
                  type="button"
                  className="employee-form__back"
                  aria-label="Back"
                  onClick={() => {
                    setState({
                      ...state,
                      reportingManagerSelect: '',
                      isModal: false
                    });
                  }}
                >
                  <i className="icofont-rounded-left" aria-hidden />
                </button>
                <div className="employee-form__profile">
                  <label className="employee-form__avatar-ring" htmlFor="employee-profile-pic">
                    <img
                      className="employee-form__avatar"
                      src={
                        state?.isEditModalData?.profilePicture
                          ? state?.isEditModalData?.profilePicture
                          : withoutProfilePicture(state?.isEditModalData)
                      }
                      alt="Employee"
                    />
                    <span
                      className={`employee-form__avatar-overlay${profilePicUploading ? ' is-uploading' : ''}`}
                    >
                      {profilePicUploading ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden
                        />
                      ) : (
                        <>
                          <i className="icofont-camera" aria-hidden />
                          <span>Upload photo</span>
                        </>
                      )}
                    </span>
                    <input
                      id="employee-profile-pic"
                      ref={profilePicInputRef}
                      type="file"
                      accept="image/*"
                      className="employee-form__avatar-input"
                      disabled={profilePicUploading}
                      onChange={handleProfilePicChange}
                    />
                  </label>
                  <div className="employee-form__identity">
                    <div className="employee-form__title-row">
                      <h2 className="employee-form__title">
                        {state.isEditModalData?.name ||
                          valuesData?.name ||
                          (state.isEditModalData?._id
                            ? LB_EDIT_EMPLOYEE_HEADER
                            : LB_ADD_EMPLOYEE_HEADER)}
                      </h2>
                      {state.isEditModalData?.hrxRole?.roleName ? (
                        <span className="employee-form__chip employee-form__chip--role">
                          {state.isEditModalData.hrxRole.roleName}
                        </span>
                      ) : null}
                    </div>
                    <div className="employee-form__meta-row">
                      <p className="employee-form__meta">
                        <i className="icofont-email" aria-hidden />
                        {state.isEditModalData?.email ||
                          valuesData?.email ||
                          'Complete the employee profile'}
                      </p>
                      {state.isEditModalData?.designation?.name ? (
                        <span className="employee-form__meta-item">
                          {state.isEditModalData.designation.name}
                        </span>
                      ) : null}
                      {state.isEditModalData?.zohoEmployeeId || valuesData?.zohoEmployeeId ? (
                        <span className="employee-form__meta-item">
                          ID {state.isEditModalData?.zohoEmployeeId || valuesData?.zohoEmployeeId}
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <nav className="employee-form__tabs" aria-label="Employee sections">
                <div className="employee-form__tabs-list">
                  <button
                    type="button"
                    className={`employee-form__tab${formTab === 'personal' ? ' is-active' : ''}`}
                    onClick={() => setFormTab('personal')}
                  >
                    <i className="icofont-user" aria-hidden />
                    {LB_PERSONAL_INFORMATION}
                  </button>
                  <button
                    type="button"
                    className={`employee-form__tab${formTab === 'work' ? ' is-active' : ''}`}
                    onClick={() => setFormTab('work')}
                  >
                    <i className="icofont-briefcase" aria-hidden />
                    {LB_WORK}
                  </button>
                  <button
                    type="button"
                    className={`employee-form__tab${formTab === 'experience' ? ' is-active' : ''}`}
                    onClick={() => setFormTab('experience')}
                  >
                    <i className="icofont-architecture-alt" aria-hidden />
                    {LB_WORK_EXPERIENCE}
                  </button>
                  <button
                    type="button"
                    className={`employee-form__tab${formTab === 'education' ? ' is-active' : ''}`}
                    onClick={() => setFormTab('education')}
                  >
                    <i className="icofont-education" aria-hidden />
                    {LB_EDUCATION_DETAIL}
                  </button>
                </div>
                <div className="employee-form__switches">
                  <label className="employee-form__wfh" htmlFor="active-toggle">
                    <div>
                      <span className="employee-form__wfh-label">Employee status</span>
                      <span className="employee-form__wfh-hint">
                        {valuesData?.isActive !== false ? 'Active' : 'Inactive'}
                      </span>
                    </div>
                    <Controller
                      name="isActive"
                      control={control}
                      defaultValue={true}
                      render={({ field }) => (
                        <div className="form-check form-switch theme-switch d-flex align-items-center">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={field.value !== false}
                            id="active-toggle"
                            {...register('isActive')}
                            onChange={field.onChange}
                          />
                        </div>
                      )}
                    />
                  </label>
                  <label className="employee-form__wfh" htmlFor="wfh-toggle">
                    <div>
                      <span className="employee-form__wfh-label">Work from home</span>
                      <span className="employee-form__wfh-hint">
                        {valuesData?.allowWorkFromHome ? 'Allowed' : 'Office only'}
                      </span>
                    </div>
                    <Controller
                      name="allowWorkFromHome"
                      control={control}
                      defaultValue={false}
                      render={({ field }) => (
                        <div className="form-check form-switch theme-switch d-flex align-items-center">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={field.value}
                            id="wfh-toggle"
                            {...register('allowWorkFromHome')}
                            onChange={field.onChange}
                          />
                        </div>
                      )}
                    />
                  </label>
                </div>
              </nav>

              <div className="employee-form__main">
                <section
                  className={`employee-form__section${formTab !== 'personal' ? ' d-none' : ''}`}
                >
                  <div className="employee-form__group">
                    <h3 className="employee-form__group-title">Basic details</h3>
                    <div className="row g-3">
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput877"
                            className="employee-form__label"
                          >
                            {LB_FULL_NAME}
                          </label>
                          <input
                            type="text"
                            {...register('name')}
                            className="form-control"
                            id="exampleFormControlInput877"
                            placeholder={PH_FULL_NAME}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput777"
                            className="employee-form__label"
                          >
                            {LB_EMPLOYEE_ROLE}
                          </label>
                          <Select
                            classNamePrefix="employee-form-select"
                            options={roleOptions}
                            placeholder={PH_EMPLOYEE_ROLE}
                            defaultValue={roleOptions?.find(
                              (opt) => opt.value === state?.isEditModalData?.hrxRole?._id
                            )}
                            onChange={(selectedOption) => {
                              setValue('hrxRoleData', selectedOption.value);
                              setState({
                                ...state,
                                roleSelect: selectedOption.value
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label htmlFor="employee-code-input" className="employee-form__label">
                            {LB_EMPLOYEE_CODE}
                          </label>
                          <input
                            type="text"
                            {...register('zohoEmployeeId')}
                            className="form-control"
                            id="employee-code-input"
                            placeholder={PH_EMPLOYEE_CODE}
                          />
                          <small className="text-danger">
                            {getErrorMessage('zohoEmployeeId', errors)}
                          </small>
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput1778"
                            className="employee-form__label"
                          >
                            {LB_PERSONAL_EMAIL}
                          </label>
                          <input
                            type="text"
                            {...register('personalEmail')}
                            className="form-control"
                            id="exampleFormControlInput1778"
                            placeholder={LB_PERSONAL_EMAIL}
                          />
                          <small className="text-danger">
                            {getErrorMessage('personalEmail', errors)}
                          </small>
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput1778"
                            className="employee-form__label"
                          >
                            Confirmation
                          </label>
                          <select className="form-control" {...register('isConfirmationDone')}>
                            <option value="">Please select</option>
                            {CONFIRMATION_SWITCH.map((val, i) => {
                              return (
                                <option key={i} value={val.value}>
                                  {val.label}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput777"
                            className="employee-form__label"
                          >
                            {LB_MOBILE}
                          </label>
                          <input
                            type="text"
                            {...register('phone')}
                            className="form-control"
                            id="exampleFormControlInput777"
                            placeholder={PH_MOBILE}
                          />
                          <small className="text-danger">{getErrorMessage('phone', errors)}</small>
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div
                          className={`employee-form__field${isExistingEmployee ? ' employee-form__field--locked' : ''}`}
                        >
                          <label htmlFor="employee-company-email" className="employee-form__label">
                            {LB_COM_EMAIL}
                            {isExistingEmployee ? <i className="icofont-lock" aria-hidden /> : null}
                          </label>
                          <input
                            type="text"
                            {...register('email')}
                            className="form-control"
                            id="employee-company-email"
                            placeholder={LB_COM_EMAIL}
                            disabled={isExistingEmployee}
                          />
                          <small className="text-danger">{getErrorMessage('email', errors)}</small>
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput777"
                            className="employee-form__label"
                          >
                            {LB_EMERGENCY_MOBILE}
                          </label>
                          <input
                            type="text"
                            {...register('emergencyMobile')}
                            className="form-control"
                            id="exampleFormControlInput777"
                            placeholder={LB_EMERGENCY_MOBILE}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label
                            htmlFor="employee-date-of-joining"
                            className="employee-form__label"
                          >
                            {LB_DATE_OF_JOINING}
                          </label>
                          <input
                            type="date"
                            value={editDateFormate(valuesData.dateOfJoining)}
                            onChange={(e) => {
                              const date = convertTimeStamp(e.target.value);
                              setValue('dateOfJoining', date);
                            }}
                            className="form-control"
                            id="employee-date-of-joining"
                            placeholder={LB_DATE_OF_JOINING}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput1778"
                            className="employee-form__label"
                          >
                            {LB_DOB}
                          </label>
                          <input
                            type="date"
                            value={editDateFormate(valuesData.dateOfBirth)}
                            onChange={(e) => {
                              const date = convertTimeStamp(e.target.value);
                              setValue('dateOfBirth', date);
                            }}
                            className="form-control"
                            id="exampleFormControlInput1778"
                            placeholder={LB_DOB}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput1778"
                            className="employee-form__label"
                          >
                            {LB_SOURCE_HR}
                          </label>
                          <select className="form-control" {...register('sourceOfHire')}>
                            <option value="">{PH_SOURCE_HIRE}</option>
                            {SOURCE_OF_HIRE.map((val, i) => {
                              return (
                                <option key={i} value={val.value}>
                                  {val.label}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput1778"
                            className="employee-form__label"
                          >
                            {LB_NATIONALITY}
                          </label>
                          <select className="form-control" {...register('nationality')}>
                            <option value="">{PH_NATIONALITY}</option>
                            {countryData.map((val, i) => {
                              return (
                                <option key={i} value={val.name}>
                                  {val.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label className="employee-form__label">{LB_GENDER_LABEL}</label>
                          <div className="employee-form__radios">
                            {GENDER_OPTION.map((checkbox) => (
                              <label
                                key={checkbox.value}
                                className={`employee-form__radio${checkbox.value === valuesData.gender ? ' employee-form__radio--active' : ''}`}
                              >
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  value={checkbox.value}
                                  checked={checkbox.value === valuesData.gender ? true : false}
                                  onChange={(e) => {
                                    setValue('gender', e.target.value);
                                  }}
                                />
                                <span>{checkbox.label}</span>
                              </label>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label className="employee-form__label">{LB_MARITAL_STATUS_LABEL}</label>
                          <div className="employee-form__radios">
                            {MARITAL_STATUS_OPTION.map((checkbox) => (
                              <label
                                key={checkbox.value}
                                className={`employee-form__radio${checkbox.value === valuesData.maritalStatus ? ' employee-form__radio--active' : ''}`}
                              >
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  value={checkbox.value}
                                  checked={
                                    checkbox.value === valuesData.maritalStatus ? true : false
                                  }
                                  onChange={(e) => {
                                    setValue('maritalStatus', e.target.value);
                                  }}
                                />
                                <span>{checkbox.label}</span>
                              </label>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput777"
                            className="employee-form__label"
                          >
                            {LB_ADDRESS}
                          </label>
                          <textarea
                            {...register('location')}
                            className="form-control"
                            id="exampleFormControlInput777"
                            placeholder={LB_ADDRESS}
                            rows={2}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className={`employee-form__section${formTab !== 'work' ? ' d-none' : ''}`}>
                  <div className="employee-form__group">
                    <h3 className="employee-form__group-title">Work information</h3>
                    <div className="row g-3">
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput777"
                            className="employee-form__label"
                          >
                            {LB_DESIGNATION_LABEL}
                          </label>
                          <Select
                            classNamePrefix="employee-form-select"
                            isSearchable
                            filterOption={designationUsesServerSearch ? () => true : undefined}
                            onMenuOpen={openDesignationDropdown}
                            options={designationOptions}
                            isLoading={designationDropdownFetching}
                            onInputChange={handleDesignationInputChange}
                            onChange={(selectedOption) => {
                              setValue('designation', selectedOption.value, {
                                shouldValidate: true
                              });
                            }}
                            onMenuClose={resetDesignationDropdown}
                            onMenuScrollToBottom={handleMenuScrollToBottomDesignation}
                            placeholder="Select option..."
                            defaultValue={{
                              value: state?.isEditModalData?.designation?._id,
                              label: state?.isEditModalData?.designation?.name
                            }}
                          />
                          <small className="text-danger">
                            {getErrorMessage('designation', errors)}
                          </small>
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput777"
                            className="employee-form__label"
                          >
                            {LB_DEPARTMENT_LABEL}
                          </label>
                          <Select
                            classNamePrefix="employee-form-select"
                            isSearchable
                            filterOption={departmentUsesServerSearch ? () => true : undefined}
                            onMenuOpen={openDepartmentDropdown}
                            options={departmentOptions}
                            isLoading={departmentDropdownFetching}
                            onInputChange={handleDepartmentInputChange}
                            onMenuScrollToBottom={handleMenuScrollToBottomDepartment}
                            onMenuClose={resetDepartmentDropdown}
                            placeholder="Select option..."
                            defaultValue={{
                              value: state?.isEditModalData?.department?._id,
                              label: state?.isEditModalData?.department?.name
                            }}
                            onChange={(selectedOption) => {
                              setValue('department', selectedOption.value);
                              setState({
                                ...state,
                                departmentSelect: selectedOption.value
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput777"
                            className="employee-form__label"
                          >
                            {LB_REPORTING_MANAGER}
                          </label>
                          <Select
                            classNamePrefix="employee-form-select"
                            isMulti
                            onMenuOpen={() => {
                              employeeDropDownQuery();
                              if (isAuOffice) adminDropDownQuery();
                            }}
                            options={projectManagerOptions}
                            isLoading={dropdownDataIsFetching || dropdownDataLoading}
                            onMenuScrollToBottom={handleMenuScrollToBottom}
                            placeholder="Select option..."
                            onChange={(selectedOptions) => {
                              const values = selectedOptions
                                ? selectedOptions.map((opt) => opt.value)
                                : [];

                              setState({
                                ...state,
                                reportingManager: values
                              });

                              setValue('reportingManager', values, { shouldValidate: true });
                            }}
                            defaultValue={
                              state?.isEditModalData?.reportingManager?.length > 0
                                ? state.isEditModalData.reportingManager.map((item) => ({
                                    value: item._id,
                                    label: item.name
                                  }))
                                : []
                            }
                          />
                          <small className="text-danger">
                            {getErrorMessage('reportingManager', errors)}
                          </small>
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput777"
                            className="employee-form__label"
                          >
                            {LB_REPORTING_TL}
                          </label>
                          <Select
                            classNamePrefix="employee-form-select"
                            key={`reporting-tl-${state.isEditModalData?._id || 'new'}`}
                            onMenuOpen={() => {
                              teamLeadDropDownQuery();
                              if (isAuOffice) adminDropDownQuery();
                            }}
                            options={teamLeadOptions}
                            isLoading={teamLeadLoading || teamLeadDataIsFetching}
                            onMenuScrollToBottom={handleMenuScrollToBottomTeamLead}
                            placeholder="Select option..."
                            onChange={(selectedOption) => {
                              setState({
                                ...state,
                                reportingTeamLead: selectedOption.value
                              });
                              setValue('reportingTeamLead', selectedOption.value);
                            }}
                            defaultValue={
                              state?.isEditModalData?.reportingTeamLead &&
                              state.isEditModalData.reportingTeamLead.length > 0
                                ? {
                                    value: state.isEditModalData.reportingTeamLead[0]._id,
                                    label:
                                      state.isEditModalData.reportingTeamLead[0].name ||
                                      state.isEditModalData.reportingTeamLead[0].userName
                                  }
                                : null
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-xl-4">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput777"
                            className="employee-form__label"
                          >
                            {LB_EMPLOYEE_TYPE}
                          </label>
                          <SingleSelectBox
                            value={valuesData.employmentType}
                            handleSelectedData={(val) => {
                              setValue('employmentType', val);
                            }}
                            options={EMPLOYEE_TYPE_OPTION}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="employee-form__field">
                          <label
                            htmlFor="exampleFormControlInput777"
                            className="employee-form__label"
                          >
                            {LB_COMPANY_ADDRESS}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={LB_COMPANY_ADDRESS}
                            {...register('companyAddress')}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section
                  className={`employee-form__section${formTab !== 'experience' ? ' d-none' : ''}`}
                >
                  <div className="employee-form__group">
                    <h3 className="employee-form__group-title">Work experience</h3>
                    <div className="employee-form__table-wrap">
                      <table className="table employee-form__table align-middle">
                        <thead>
                          <tr>
                            <th scope="col">{LB_COMPANY_NAME}</th>
                            <th scope="col">{LB_JOB_TITLE}</th>
                            <th scope="col">{LB_FROM_DATE}</th>
                            <th scope="col">{LB_TO_DATE}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {experienceRows.length ? (
                            experienceRows.map((val, i) => (
                              <tr key={i}>
                                <td>
                                  <span className="employee-form__cell">{val.company}</span>
                                </td>
                                <td>
                                  <span className="employee-form__cell">{val.title}</span>
                                </td>
                                <td>
                                  <span className="employee-form__cell">
                                    {val.start ? moment(val.start).format('DD MMM YYYY') : '-'}
                                  </span>
                                </td>
                                <td>
                                  {val.end === 0 ? (
                                    <span className="employee-form__badge">Current</span>
                                  ) : (
                                    <span className="employee-form__cell">
                                      {val.end ? moment(val.end).format('DD MMM YYYY') : '-'}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={4} className="employee-form__empty">
                                {isExistingEmployee && isEmployeeDetailFetching
                                  ? 'Loading work experience...'
                                  : 'No work experience added'}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </section>

                <section
                  className={`employee-form__section${formTab !== 'education' ? ' d-none' : ''}`}
                >
                  <div className="employee-form__group">
                    <h3 className="employee-form__group-title">Education detail</h3>
                    <div className="employee-form__table-wrap">
                      <table className="table employee-form__table align-middle">
                        <thead>
                          <tr>
                            <th scope="col">{LB_INSTITUTE_NAME}</th>
                            <th scope="col">{LB_DEGREE}</th>
                            <th scope="col">{LB_SPECIALIZATION}</th>
                            <th scope="col">{LB_DATE_COMPLETION}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {educationRows.length ? (
                            educationRows.map((val, i) => (
                              <tr key={i}>
                                <td>
                                  <span className="employee-form__cell">{val.institute}</span>
                                </td>
                                <td>
                                  <span className="employee-form__cell">{val.degree}</span>
                                </td>
                                <td>
                                  <span className="employee-form__cell">{val.specialization}</span>
                                </td>
                                <td>
                                  <span className="employee-form__cell">{val.year}</span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={4} className="employee-form__empty">
                                {isExistingEmployee && isEmployeeDetailFetching
                                  ? 'Loading education details...'
                                  : 'No education details added'}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </section>
              </div>

              <div className="employee-form__footer">
                <button
                  type="button"
                  className="employee-form__cancel"
                  onClick={() => {
                    setState({
                      ...state,
                      reportingManagerSelect: '',
                      isModal: false
                    });
                  }}
                >
                  {BTN_CANCEL}
                </button>
                <button type="submit" disabled={isSavingDisabled} className="employee-form__save">
                  {isSavingDisabled ? (
                    <div className="spinner-border spinner-border-sm" role="status"></div>
                  ) : (
                    BTN_SAVE
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      ) : null}
      <div className={`container-xxl${state.isModal ? ' d-none' : ''}`}>
        <PageHeader
          headerTitle="Employee"
          renderRight={() => {
            return (
              <div className="col-auto d-flex w-sm-100">
                {/* <button
                className="btn btn-dark btn-set-task w-sm-100 me-2"
                onClick={() => {
                  setState({ ...state, isModal: true, isEditModalData: {} });
                }}
              >
                <i className="icofont-plus-circle me-2 fs-6"></i>
                {BTN_ADD_EMPLOYEE}
              </button> */}
              </div>
            );
          }}
        />

        {state.grid === true ? (
          <div className="row g-3 row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 row-cols-xl-2 row-cols-xxl-2 row-deck py-1 pb-4">
            {isLoading || isFetching ? (
              <div className="loading-card w-100">
                <CardSkeleton count={6} />
              </div>
            ) : data?.data?.length > 0 ? (
              data?.data?.map((data, i) => {
                return (
                  <div key={'skhd' + i} className="col mb-5">
                    <OurClients
                      avatar={''}
                      post={data?.role?.roleName}
                      name={fullName(data)}
                      Companyname={data?.email}
                      isMember={false}
                      onClickDelete={() => {
                        setState({ ...state, isDelete: { id: data?._id, status: true } });
                      }}
                      onClickEdit={() => openEmployeeDetails(data)}
                    />
                  </div>
                );
              })
            ) : (
              <EmptyData />
            )}
            <div className="pagination-layout">
              <div className="row-select">
                {ROW}&nbsp;
                <select
                  onChange={(e) => {
                    handleChangeRowsPerPage(e.target.value);
                  }}
                >
                  {TABLE_ROW.map((val, i) => {
                    return (
                      <option key={i} value={val.value}>
                        {val.label}
                      </option>
                    );
                  })}
                </select>
              </div>
              <button
                disabled={state.currentPage <= 1 ? true : false}
                onClick={() => {
                  handleChangePage(state.currentPage - 1);
                }}
                className="pagination-button"
              >
                <i class="icofont-rounded-left"></i>
              </button>
              <div className="count-layout">
                <span className="pagination-font">
                  {state.currentPage}-{state.rowsPerPage} of{' '}
                  {state.isNext
                    ? state.rowsPerPage * state.currentPage + data?.data?.length
                    : state.rowsPerPage * state.currentPage}
                </span>
              </div>
              <button
                disabled={state.isNext ? false : true}
                onClick={() => {
                  handleChangePage(state.currentPage + 1);
                }}
                className="pagination-button"
              >
                <i class="icofont-simple-right"></i>
              </button>
            </div>
          </div>
        ) : (
          <div className="row clearfix g-3">
            <div className="employee-list-table">
              <div className="employee-list-table__toolbar">
                <div className="employee-list-search">
                  <i className="icofont-search employee-list-search__icon" />
                  <input
                    className="form-control employee-list-search__input"
                    placeholder={PH_SEARCH_INPUT}
                    onChange={(e) => {
                      debouncedOnSearchData(e.target.value);
                    }}
                  />
                </div>
                <div className="employee-status-filter">
                  <Select
                    classNamePrefix="employee-status-select"
                    options={EMPLOYEE_ACTIVE_OPTIONS}
                    value={EMPLOYEE_ACTIVE_OPTIONS.find(
                      (option) => option.value === state.isActiveFilter
                    )}
                    onChange={(option) => {
                      if (!option) return;
                      setState((prev) => ({
                        ...prev,
                        isActiveFilter: option.value,
                        currentPage: 1
                      }));
                    }}
                    isSearchable={false}
                    formatOptionLabel={(option) => (
                      <span className="employee-status-option">
                        <span
                          className={`employee-status-option__dot${option.value ? ' is-on' : ' is-off'}`}
                        />
                        {option.label}
                      </span>
                    )}
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                  />
                </div>
              </div>
              <DataTable
                title={HolidaysData.title}
                columns={columnsT}
                data={state?.employeeList || []}
                defaultSortField="title"
                pagination
                paginationServer
                onSort={handleChangeSort}
                sortField={state.sortField}
                sortDirection={state.sortDirection}
                paginationTotalRows={data?.totalCount}
                paginationPerPage={state.rowsPerPage}
                paginationRowsPerPageOptions={[5, 10, 20, 30]}
                paginationComponentOptions={{
                  noRowsPerPage: false,
                  rangeSeparatorText: 'of',
                  selectAllRowsItem: state.isNext,
                  selectAllRowsItemText: 'All',
                  paginationButtonsDisabled: state.isNext
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                selectableRows={false}
                className="employee-list-table__datatable"
                customStyles={employeeTableStyles}
                highlightOnHover={true}
                progressPending={isLoading || isFetching ? true : false}
                noDataComponent={<EmptyData />}
                progressComponent={<TableSkeleton columns={7} />}
              />
            </div>
          </div>
        )}
        <ConfirmDialog
          show={Boolean(state.activeConfirm)}
          onHide={closeActiveConfirm}
          onConfirm={confirmActiveChange}
          loading={state.activeSaving}
          variant={state.activeConfirm?.nextValue ? 'primary' : 'warning'}
          title={state.activeConfirm?.nextValue ? 'Mark as active?' : 'Mark as inactive?'}
          confirmLabel={state.activeConfirm?.nextValue ? 'Active' : 'Inactive'}
          message={
            state.activeConfirm
              ? `Are you sure you want to mark ${fullName(state.activeConfirm.row)} as ${
                  state.activeConfirm.nextValue ? 'active' : 'inactive'
                }?`
              : ''
          }
        />
        <DeleteModel
          isOpen={() => {
            setState({ ...state, isDelete: { id: '', status: false } });
          }}
          open={state?.isDelete?.status}
          title="Delete Employee"
          message="Are you sure you want to Delete Employee ?"
          isDelete={() => {
            onDeleteUser(state?.isDelete.id);
          }}
        />
      </div>
    </>
  );
}

export default Members;
